const backendAr = {
  auth_not_authenticated: 'يرجى تسجيل الدخول للمتابعة.',
  auth_permission_denied_add_org: 'ليست لديك صلاحية لإضافة مؤسسة.',
  payload_missing_required_fields: 'بعض المعلومات المطلوبة غير متوفرة.',
  organisation_invalid_type: 'نوع المؤسسة غير صالح.',
  organisation_duplicate_owner_name: 'توجد مؤسسة بالاسم نفسه بالفعل.',
  organisation_create_failed: 'تعذر إنشاء المؤسسة.',
  organisation_set_claims_failed_owner: 'تعذر تحديث صلاحيات المالك.',
  organisation_set_claims_failed_user: 'تعذر تحديث صلاحيات المستخدم.',
  organisation_add_failed: 'تعذر إضافة المؤسسة.',
  organisation_not_found: 'تعذر العثور على هذه المؤسسة.',
  organisation_missing_fields: 'سجل المؤسسة يفتقر إلى معلومات ضرورية.',
  onboarding_not_new_user: 'هذا الحساب أنهى عملية الإعداد بالفعل.',
  onboarding_unknown_error: 'حدث خطأ أثناء إكمال عملية الإعداد.',
  email_invalid_argument: 'يرجى إدخال بريد إلكتروني صالح.',
  email_already_verified: 'تم التحقق من هذا البريد الإلكتروني مسبقًا.',
  email_no_data: 'تعذر تجهيز بريد التحقق.',
  email_sending_failed: 'تعذر إرسال البريد. حاول لاحقًا.',
  email_verification_failed: 'تعذر إرسال بريد تحقق جديد.',
  promoter_not_found: 'تعذر العثور على هذا المروج.',
  promoter_missing_claims: 'ملف المروج غير مكتمل.',
  password_strength_failed: 'اختر كلمة مرور أقوى تستوفي جميع المتطلبات.',
  invitation_invalid_token: 'رابط الدعوة غير صالح أو منتهٍ. افتح أحدث رسالة دعوة في بريدك.',
  invitation_not_found: 'تعذر العثور على هذه الدعوة.',
  invitation_not_pending: 'هذه الدعوة لم تعد قيد الانتظار.',
  invitation_missing_id: 'معرّف الدعوة مفقود.',
  invitation_public_cancel_denied: 'لا يمكن إلغاء الدعوات العامة.',
  invitation_not_inviter: 'فقط صاحب الدعوة يمكنه إدارة هذه الدعوة.',
  invitation_not_inviter_or_delegate: 'فقط صاحب الدعوة أو المفوَّض عنه يمكنه إدارة هذه الدعوة.',
  invitation_promoter_not_public: 'هذا المروج لا يقبل الدعوات العامة.',
  invitation_invalid_email_format: 'يرجى إدخال بريد إلكتروني وكلمة مرور صالحين.',
  invitation_invalid_role_division: 'الدور أو القسم المختار غير مسموح به.',
  invitation_already_accepted: 'هذا الشخص وافق على دعوة بالفعل.',
  invitation_email_in_use: 'هذا البريد الإلكتروني مسجل مسبقًا.',
  invitation_create_failed: 'تعذر إنشاء الدعوة.',
  invitation_create_user_failed: 'تعذر إنشاء حساب المستخدم.',
  invitation_create_user_ref_failed: 'تعذر ربط حساب المستخدم.',
  invitation_inviter_data_failed: 'تعذر تحميل بيانات صاحب الدعوة.',
  invitation_inviter_claims_failed: 'تعذر تحميل صلاحيات صاحب الدعوة.',
  invitation_custom_claims_too_large: 'صلاحيات الدعوة كبيرة جدًا.',
  invitation_invite_permission_denied: 'ليست لديك صلاحية لدعوة الآخرين.',
  invitation_fetch_failed: 'تعذر تحميل الدعوات.',
  invitation_user_missing_email: 'يجب أن يحتوي حسابك على بريد إلكتروني.',
  invitation_owner_missing: 'تعذر العثور على مالك المروج.',
  invitation_role_not_authorized: 'هذا الدور غير مخوّل لإرسال الدعوات.',
  invitation_role_not_found: 'تعذر العثور على هذا الدور.',
  invitation_pending_exists: 'هناك دعوة جارية بالفعل لهذا الشخص.',
  invitation_cancel_unknown: 'تعذر إلغاء الدعوة.',
  invitation_reject_unknown: 'تعذر رفض الدعوة.',
  invitation_request_unknown: 'تعذر إرسال طلب الدعوة.',
  verify_email_unknown: 'تعذر التحقق من البريد الإلكتروني.',
  superuser_unauthorized: 'فقط المستخدمون المميزون يمكنهم تنفيذ هذا الإجراء.',
  superuser_invitations_unknown: 'تعذر تحميل قائمة الدعوات.',
  superuser_users_unknown: 'تعذر تحميل قائمة المستخدمين.',
  superuser_organisations_unknown: 'تعذر تحميل قائمة المؤسسات.',
  signup_requires_auth: 'يرجى تسجيل الدخول للمتابعة.',
  signup_unknown_error: 'حدث خطأ أثناء إنشاء الحساب.',
  signup_update_password_failed: 'تعذر تحديث كلمة المرور.',
  provider_already_exists: 'هذا المزوّد موجود بالفعل.',
  custom_claims_set_failed: 'تعذر تحديث صلاحيات الحساب.',
} as const;

export default backendAr;
